import { makeAutoObservable } from "mobx"
import { AxiosResponse } from "axios"

import { authStore } from "@src/app/authStore"
import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { APIResponse, authApi, catchErrors } from "@src/shared/api"
import { MerchantResponseUserTypeEnum } from "@src/shared/api/generated"
import { router } from ".."

// const { merchant } = authStore

export class ConfirmStore {
  confirm = async (identity: { code: string; email: string }) => {
    this.isLoading = true

    return (
      authApi
        // @ts-ignore
        .confirmations(identity)
        .then((response) => {
          const { data } = response as AxiosResponse<APIResponse>

          const { user_type } = this._auth.merchant ?? {}

          const isRefer =
            user_type && user_type === MerchantResponseUserTypeEnum.Referrer

          return (
            isRefer
              ? router.navigate(paths.affiliateProgram)
              : router.navigate(paths.statusConfirmation)
          ).then(() => notify.success(data.message))
        })
        .catch(catchErrors)
        .finally(() => {
          authStore.reload()

          this.isLoading = false
        })
    )
  }
  isLoading = false

  constructor(private _auth = authStore) {
    makeAutoObservable(this)
  }
}
